const VIEWPORT_MARGIN = 10;
const TRIGGER_GAP = 10;

type PanelPosition = {
  top: number;
  left: number;
};

type GetSidebarMenuPositionArgs = {
  triggerRect: DOMRect;
  panelRect: DOMRect | null;
  estimatedPanelHeight?: number;
};

export function getSidebarMenuPosition({
  triggerRect,
  panelRect,
  estimatedPanelHeight = 220,
}: GetSidebarMenuPositionArgs): PanelPosition {
  const panelHeight = panelRect?.height ?? estimatedPanelHeight;
  const panelWidth = panelRect?.width ?? 200;

  let left = triggerRect.right + TRIGGER_GAP;

  if (left + panelWidth > window.innerWidth - VIEWPORT_MARGIN) {
    left = Math.max(
      VIEWPORT_MARGIN,
      triggerRect.left - panelWidth - TRIGGER_GAP,
    );
  }

  const triggerCenterY = triggerRect.top + triggerRect.height / 2;
  let top = triggerCenterY - panelHeight / 2;

  const maxTop = window.innerHeight - panelHeight - VIEWPORT_MARGIN;
  top = Math.min(Math.max(top, VIEWPORT_MARGIN), maxTop);

  return { top, left };
}
